import moment from 'moment';

/**
 * Check if time in range
 *
 * @param startTime Start of range HH:mm:ss
 * @param endTime End of range HH:mm:ss
 * @param serverTime Search time HH:mm:ss
 * @returns {boolean} Boolean result
 */
export const isTimeBetween = (startTime: string, endTime: string, serverTime: string) => {
  const start = moment(startTime, 'HH:mm:ss');
  const end = moment(endTime, 'HH:mm:ss');
  const server = moment(serverTime, 'HH:mm:ss');

  if (end.isBefore(start)) {
    return (
      (server.isSameOrAfter(start) && server.isSameOrBefore(moment('23:59:59', 'HH:mm:ss'))) ||
      (server.isBefore(end) && server.isSameOrAfter(moment('00:00:00', 'HH:mm:ss')))
    );
  }
  return server.isSameOrAfter(start) && server.isBefore(end);
};
